/**
 * Toast Colors
 *
 * The four status toasts (`toast.success/error/warning/info`) in each theme:
 * background, border and the text drawn on it. Sonner's own rich-colour
 * palette missed WCAG AA — its light success text was 4.29:1 on its background
 * (axe, citizen first-run evidence, 24 Sep) — so `@tonnie/ui`'s `<Toaster>`
 * sets these instead.
 *
 * Every `text` is ≥ 4.5:1 on its `bg` (WCAG AA for body text); the toast's
 * title AND description are drawn in `text`, so that pair is the whole check.
 * `toast.spec.ts` computes the ratios from these very strings — edit a value
 * and the spec says whether it still passes.
 */

export type ToastVariant = 'success' | 'error' | 'warning' | 'info';
export type ToastTheme = 'light' | 'dark';

export interface ToastColors {
  bg: string;
  border: string;
  text: string;
}

export const TOAST_COLORS: Record<ToastTheme, Record<ToastVariant, ToastColors>> = {
  light: {
    success: {
      bg: 'oklch(0.97 0.03 150)',
      border: 'oklch(0.88 0.07 150)',
      text: 'oklch(0.44 0.12 150)',
    },
    error: {
      bg: 'oklch(0.97 0.02 25)',
      border: 'oklch(0.88 0.06 25)',
      text: 'oklch(0.5 0.19 25)',
    },
    warning: {
      bg: 'oklch(0.97 0.04 85)',
      border: 'oklch(0.88 0.1 85)',
      text: 'oklch(0.47 0.1 65)',
    },
    info: {
      bg: 'oklch(0.97 0.02 240)',
      border: 'oklch(0.88 0.06 240)',
      text: 'oklch(0.47 0.14 255)',
    },
  },
  dark: {
    success: {
      bg: 'oklch(0.27 0.05 150)',
      border: 'oklch(0.4 0.08 150)',
      text: 'oklch(0.86 0.13 150)',
    },
    error: {
      bg: 'oklch(0.27 0.06 25)',
      border: 'oklch(0.42 0.1 25)',
      text: 'oklch(0.84 0.09 25)',
    },
    warning: {
      bg: 'oklch(0.28 0.05 80)',
      border: 'oklch(0.42 0.08 80)',
      text: 'oklch(0.88 0.12 85)',
    },
    info: {
      bg: 'oklch(0.27 0.05 250)',
      border: 'oklch(0.42 0.08 250)',
      text: 'oklch(0.85 0.08 240)',
    },
  },
};
